// Enumeration
import { UploadIdOcrStatesEnumeration } from '../enumerations/upload-id-ocr-states.enumeration';
// Types
import { TrackingEventsEnum, TrackingViewEventReturnType } from '@openbank/ziniaweb-ui-core-models';
import { TrackBuilderType } from 'types/track-builder.type';
import { WsResponseType } from 'types/ws-response.type';
import { UploadIdVerificationTrackingHandlersReturnType } from './types/upload-id-verification.handlers.type';

const trackWebSocketErrorHandler = (
  message: WsResponseType<UploadIdOcrStatesEnumeration>
): TrackingViewEventReturnType => {
  const parsedStatus = message?.detail?.payload?.status as any;

  return {
    payload: {
      pageName: '/error/validateTheDocuments',
      sectionFamily: 'customer',
      sectionCategory: 'orders',
      sectionName: 'lending',
      interactionType: 'page',
      serviceType: 'userSettings',
      errorCategory: 'validateTheDocuments',
      errorDescription: parsedStatus,
      errorStatus: parsedStatus,
      errorNumber: parsedStatus,
    },
    type: TrackingEventsEnum.VIEW,
  };
};

const UploadIdVerificationTrackingHandlers = (
  track: TrackBuilderType
): UploadIdVerificationTrackingHandlersReturnType => ({
  handleTrackWebSocketError: message => track(trackWebSocketErrorHandler(message)),
});

export { UploadIdVerificationTrackingHandlers };
